import { ComposedTheme } from '@glu/theming';
import '../themeDefaults';

export default ({ formComponents: theme }: ComposedTheme) => ({
  checkboxIcon: {
    '&$selected': {
      background: theme.checkboxRadio.selectedColor,
      borderColor: theme.checkboxRadio.selectedColor,
    },
    borderRadius: 2,
    display: 'inline-block',
  },
  dark: {
    '& $checkboxIcon$selected': {
      background: theme.checkboxRadio.dark.selectedColor,
      borderColor: theme.checkboxRadio.dark.selectedColor,
    },
    '& $dash': {
      color: theme.checkboxRadio.dark.borderColor,
    },
    '& $icon': {
      '& svg': {
        fill: theme.checkboxRadio.dark.checkColor,
      },
      borderColor: theme.checkboxRadio.dark.borderColor,
    },
    '& $radioDot': {
      background: theme.checkboxRadio.dark.selectedColor,
    },
    '& $radioIcon': {
      '&$selected': {
        borderColor: theme.checkboxRadio.dark.selectedColor,
      },
      borderColor: theme.checkboxRadio.dark.borderColor,
    },
    '& p': {
      color: theme.dark.color,
    },
  },
  dash: {
    color: theme.checkboxRadio.borderColor,
    height: 16,
    left: -1,
    linHeight: '16px',
    position: 'absolute',
    textAlign: 'center',
    top: -1,
    width: 16,
  },
  disabled: {
    opacity: 0.5,
  },

  icon: {
    '& svg': {
      fill: theme.checkboxRadio.checkColor,
      height: 8,
      left: 3,
      position: 'absolute',
      top: 3,
      width: 8,
    },
    background: 'transparent',
    borderColor: theme.checkboxRadio.borderColor,
    borderStyle: 'solid',
    borderWidth: 1,
    display: theme.checkboxRadioSvgDisplay,
    height: 16,
    left: 0,
    marginTop: -9,
    position: 'absolute',
    top: '50%',
    width: 16,
  },
  inline: {
    display: 'inline-block',
  },
  radioDot: {
    background: theme.checkboxRadio.selectedColor,
    borderRadius: 100,
    display: 'none',
    height: 10,
    left: 2,
    position: 'relative',
    top: 2,
    width: 10,
  },
  radioIcon: {
    '&$selected': {
      '& $radioDot': {
        display: 'block',
      },
      borderColor: theme.checkboxRadio.selectedColor,
    },
    background: 'transparent',
    borderColor: theme.checkboxRadio.borderColor,
    borderRadius: 100,
  },
  root: {
    '& input': {
      height: 16,
      left: 0,
      margin: 0,
      marginTop: -9,
      opacity: 0,
      position: 'absolute',
      top: '50%',
      width: 16,
      zIndex: 1,
    },
    '& input:focus + $icon': {
      boxShadow: `0 0px 8px ${theme.checkboxRadio.shadowColor}`,
      outline: `${theme.checkboxRadio.selectedColor} solid 1px`,
    },
    '& p': {
      margin: 0,
    },
    cursor: 'pointer',
    display: 'block',
    height: 18,
    lineHeight: '16px',
    marginBottom: 15,
    padding: [0, 0, 0, 24],
    position: 'relative',
  },
  selected: {},
});
